import { CalciteAlert } from "@esri/calcite-components-react";
import { NOTIFICATION_TYPE } from "context/NotificationContext";
import React from "react";

type AlertProps = {
  title: string;
  message: string;
  isOpen: boolean | undefined;
  type: any;
  onClose: (event) => void;
};
const Alert: React.FC<AlertProps> = ({
  title,
  message,
  type,
  onClose,
  isOpen,
}) => {
  const icon = {
    [NOTIFICATION_TYPE.SUCCESS]: "check-circle",
    [NOTIFICATION_TYPE.WARNING]: "exclamation-mark-triangle",
    [NOTIFICATION_TYPE.ERROR]: "exclamation-mark-circle",
    [NOTIFICATION_TYPE.LOADING]: "wrench",
  };

  const kind = {
    [NOTIFICATION_TYPE.SUCCESS]: "success",
    [NOTIFICATION_TYPE.WARNING]: "warning",
    [NOTIFICATION_TYPE.ERROR]: "danger",
    [NOTIFICATION_TYPE.LOADING]: "brand",
  };
  return (
    <CalciteAlert
      onCalciteAlertClose={onClose}
      open={isOpen}
      kind={kind[type]}
      label={title}
      icon={icon[type]}
    >
      <div slot="title">{title}</div>
      <div slot="message">{message}</div>
    </CalciteAlert>
  );
};

export default Alert;
